<script setup>
import Flow from "../Flow.vue";
import state from "./state";
const props = defineProps({
  formId: {
    type: Number,
  },
  flowType: {
    type: String,
  },
  courseMomentId: {
    type: Number,
  },
  courseTitle: {
    type: String,
  },
  registrationExplainer: {
    type: String,
  },
  thankYouPage: {
    type: String,
  },
  verkoopregels: {
    type: Object,
  },
  jobChoices: {
    type: Object,
  },
  termsLink: {
    type: String,
  },
  participantNotice: {
    type: String,
  },
  participantEmailNotice: {
    type: String,
  },
  invoiceNotice: {
    type: String,
  },
  referrerUrl: {
    type: String,
  },
})

state.init(props.courseMomentId);

state.value.formId = props.formId;
state.value.course = props.courseMomentId;
state.value.verkoopregels = props.verkoopregels;
state.value.jobChoices = props.jobChoices;
state.value.info = {
  flowType: props.flowType,
  courseTitle: props.courseTitle,
  thankyouPage: props.thankYouPage,
  registrationExplainer: props.registrationExplainer,
  termsLink: props.termsLink,
  participantNotice: props.participantNotice,
  participantEmailNotice: props.participantEmailNotice,
  invoiceNotice: props.invoiceNotice,
  referrerUrl: props.referrerUrl,
}
</script>

<template>
   <Flow />
</template>
